import React from "react";
import "./CricketGallery.css";

const CricketGallery = () => {
  const handleImageClick = (stadium) => {
    // Navigate to the next page
    window.location.href = `/stadium/${stadium}`;
  };

  return (
    
    <section className="cricket-gallery-sec">
    <div className="cricket-gallery-section">
      <img
        src="/Images/ballimg.png"
        alt="Cricket Gallery Top"
        className="gallery-top-image"
      />
      <p className="gallery-subtitle">A Collection of Moments</p>
      <h2 className="gallery-title">Check Out Our Gallery</h2>

      <div className="gallery-container">
        {/* Column 1 */}
        <div className="gallery-column">
          <div
            className="gallery-item"  style={{ height: "390px" }}
            onClick={() => handleImageClick("mumbai-stadium")}
          >
            <img src="/Images/crickpic.jpg" alt="Mumbai Stadium" />
            <div className="gallery-info">
              <p>Mumbai Stadium</p>
              <span>Premier Cricket League</span>
            </div>
          </div>
          <div
            className="gallery-item" style={{ height: "370px" }}
            onClick={() => handleImageClick("delhi-stadium")}
          >
            <img src="/Images/crickp4.jpg" alt="Delhi Stadium" />
            <div className="gallery-info">
              <p>Delhi Stadium</p>
              <span>Empire Cricket Cup</span>
            </div>
          </div>
        </div>

        {/* Column 2 */}
        <div className="gallery-column">
          <div
            className="gallery-item large"
            onClick={() => handleImageClick("chennai-stadium")}
          >
            <img src="/Images/stadium.jpg" alt="Chennai Stadium" />
            <div className="gallery-info">
              <p>Chennai Stadium</p>
              <span>Cricket Legends League
</span>
            </div>
          </div>
          <div className="gallery-row">
            <div
              className="gallery-item small"
              onClick={() => handleImageClick("kolkata-stadium")}
            >
              <img src="/Images/crickp2.jpg" alt="Kolkata Stadium" />
              <div className="gallery-info">
                <p>Kolkata Stadium</p>
                <span>Phoenix Flame Ground</span>
              </div>
            </div>
            <div
              className="gallery-item small"
              onClick={() => handleImageClick("ahmedabad-stadium")}
            >
              <img src="/Images/crickpd2.jpg" alt="Ahmedabad Stadium" />
              <div className="gallery-info">
                <p>Ahmedabad Stadium</p>
                <span>NextGen Cricket Clash</span>
              </div>
            </div>
          </div>
        </div>

        {/* Column 3 */}
        <div className="gallery-column">
          <div
            className="gallery-item" style={{ height: "375px" }}
            onClick={() => handleImageClick("pune-stadium")}
          >
            <img src="/Images/crickp3.jpg" alt="Pune Stadium" />
            <div className="gallery-info">
              <p>Pune Stadium</p>
              <span>Boundary League</span>
            </div>
          </div>
          <div
            className="gallery-item" style={{ height: "386px" }}
            onClick={() => handleImageClick("hydrabad-stadium")}
          >
            <img src="/Images/crickp1.jpg" alt="Hyderabad Stadium" />
            <div className="gallery-info">
              <p>Hyderabad Stadium</p>
              <span>Women's T20 Cup</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default CricketGallery;
